// extracted by mini-css-extract-plugin
module.exports = {"container":"share_container__O9m_C","buttonContainer":"share_buttonContainer__rU_t_","shareButton":"share_shareButton__D9BK3"};